import gettext from '@sdk/lang/gettext';

import { TabType } from '@web/settings/types';
import {
  SectionPropertyName,
  InformationBoxProps,
} from '@web/labor/LaborInformationBox/laborInformationBox.types';
import areAnyWagesCreated from '@web/onboarding/Checklist/helpers/areAnyWagesCreated';

export const getSectionDescription = ({
  sectionValue,
  sectionPropertyName,
  navigateTo,
  openAddShiftModal,
  hasVisitiedLaborCostSettingsTab,
  employees,
  positions,
}: InformationBoxProps) => {
  switch (sectionPropertyName) {
    case SectionPropertyName.cost:
      return {
        linkText: gettext('Add wages'),
        descriptionText: gettext('to employees or positions to be able to estimate labor cost.'),
        action: () =>
          navigateTo({ route: 'labor-cost.settings.tabs', routeParams: { tab: 'employees' } }),
        isVisible: !areAnyWagesCreated(employees, positions),
      };
    case SectionPropertyName.totalOvertimeCost:
      return {
        linkText: gettext('Add threshold'),
        descriptionText: gettext('for weekly overtime to be able to calculate overtime cost.'),
        action: () => navigateTo({ route: 'settings', routeParams: { tab: TabType.laborCost } }),
        // Hint is present until labor cost settings has been visited once
        isVisible: !hasVisitiedLaborCostSettingsTab,
      };
    case SectionPropertyName.paidMinutes:
      return {
        linkText: gettext('Add shifts'),
        descriptionText: gettext('to be able to calculate the scheduled hours.'),
        action: openAddShiftModal,
        // Hint is present until at least one shift has created
        isVisible: !sectionValue,
      };
    case SectionPropertyName.totalOvertimeHours:
      return {
        linkText: gettext('Add threshold'),
        descriptionText: gettext('for weekly overtime to be able to calculate overtime hours.'),
        action: () => navigateTo({ route: 'settings', routeParams: { tab: TabType.laborCost } }),
        // Hint is present until labor cost settings has been visited once
        isVisible: !hasVisitiedLaborCostSettingsTab,
      };
    case SectionPropertyName.laborPercentage:
      return {
        linkText: gettext('Add labor % target'),
        descriptionText: gettext('to be able to stay within the limit.'),
        action: () => navigateTo({ route: 'settings', routeParams: { tab: TabType.laborCost } }),
        // Hint is present until labor cost settings has been visited once
        isVisible: !hasVisitiedLaborCostSettingsTab,
      };
    default:
      return {
        linkText: gettext('Check settings'),
        descriptionText: gettext('to find out more'),
        action: () => navigateTo({ route: 'settings', routeParams: { tab: TabType.timeOff } }),
        isVisible: true,
      };
  }
};
